/**
 * Derive a friendly display name from a Cognito identity.
 *
 * Cognito users in this console authenticate via email-only (loginMechanisms=['email']
 * + hideSignUp=true), so we have no `given_name` / `family_name` claim by default.
 * The local-part of the email is the most user-recognizable identifier; we
 * split on dots/underscores/hyphens and Title Case each segment.
 *
 *   deriveFriendlyName('seb.alzate@gmail.com') === 'Seb Alzate'
 *   deriveFriendlyName(undefined, 'seb_alzate')   === 'Seb Alzate'
 *   deriveFriendlyName(undefined, undefined)      === undefined
 */
export function deriveFriendlyName(
  email: string | undefined,
  username: string | undefined,
): string | undefined {
  const localPart = (email ?? '').split('@')[0];
  const source = (localPart || username || '').trim();
  if (!source) return undefined;
  return source
    .split(/[._-]+/)
    .filter(Boolean)
    .map(s => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
}
